import React, { useEffect, useState } from "react";
import BannerSlider from "../../../components/common/Banner/Banner";
import homePageStyles from "../../../styles/PublicPage/home";
import VideoSection from "./VideoSection";
import ProductCarousel from "./ProductCarousel";
import FindUsSection from "./FindUsSection";
import TastebudSection from "./TasteBudSection";
import colorConfigs from "../../../configs/colorConfigs";
import { Stack, Typography, Box } from "@mui/material";
import { typo } from "../../../assets/fonts/font";
import { PATH_NAME } from "../../../configs/pathName";
import { generalItemFetcher } from "../../../helpers/Fetchers/fetchers";
import { IBanner, IBannerItems } from "../../../models/IBanner";
import useSWR from "swr";

const HomePage: React.FC = () => {
  const { data: assets }: { data: IBanner[] } = useSWR(PATH_NAME.API_ASSETS,generalItemFetcher);
  const [bannerItems, setBannerItems] = useState<IBannerItems[]>([]);
  const [videoItems, setVideoItems] = useState<IBannerItems[]>([]);
  const [tasteBudsItems, setTasteBudsItems] = useState<IBannerItems[]>([]);

  useEffect(() => {
    console.log("assets", assets);
    if (assets) {
      const banner = assets.find((asset) => asset.placement === "banner");
      if (banner && banner.items) {
        setBannerItems(banner.items);
      }
      const video = assets.find((asset) => asset.placement === "video");
      if (video && video.items) {
        setVideoItems(video.items);
      }
      const tasteBuds = assets.find((asset) => asset.placement === "tastebud");
      if (tasteBuds && tasteBuds.items) {
        setTasteBudsItems(tasteBuds.items);
      }
    }
  }, [assets]);

  return (
    <Box sx={homePageStyles.Box}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "85vh",
          background: colorConfigs.secondary,
        }}
      >
        <BannerSlider items={bannerItems} />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "80vh",
          justifyContent: "center",
          alignItems: "center",
          background: colorConfigs.secondary,
        }}
      >
        <VideoSection items={videoItems} />
      </Box>
      <Stack
        direction="column"
        spacing={2}
        sx={{
          minHeight: "80vh",
          background: colorConfigs.secondary,
        }}
      >
        <Box
          sx={{
            mx: "auto",
            textAlign: "center",
          }}
        >
          <Typography sx={{ ...typo.sectionHeadline }}>
            Take your tastebuds on a joyride
          </Typography>
        </Box>
        <ProductCarousel />
      </Stack>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          justifyContent: "space-evenly",
          background: colorConfigs.secondary,
        }}
      >
        <FindUsSection />
        <TastebudSection items={tasteBudsItems} />
      </Box>
    </Box>
  );
};

export default HomePage;
